(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anu-benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-anu-benefits]').forEach((sectionEl) => {
      const mobileSliderEl = sectionEl.querySelector('[data-anu-benefits-mobile-slider]');
      const prevEl = sectionEl.querySelector('[data-anu-benefits-prev]');
      const nextEl = sectionEl.querySelector('[data-anu-benefits-next]');

      if (!mobileSliderEl || !prevEl || !nextEl) {
        return;
      }

      const updateControls = () => {
        const maxScrollLeft = mobileSliderEl.scrollWidth - mobileSliderEl.clientWidth;
        const currentScrollLeft = mobileSliderEl.scrollLeft;
        const threshold = 2;

        prevEl.disabled = currentScrollLeft <= threshold;
        nextEl.disabled = currentScrollLeft >= maxScrollLeft - threshold;
      };

      const scrollByPage = (direction) => {
        const firstPage = mobileSliderEl.querySelector('.anu-benefits__mobile-page');
        if (!firstPage) {
          return;
        }

        const gap = parseFloat(window.getComputedStyle(mobileSliderEl).columnGap || '0');
        mobileSliderEl.scrollBy({
          left: direction * (firstPage.getBoundingClientRect().width + gap),
          behavior: 'smooth',
        });
      };

      prevEl.addEventListener('click', () => scrollByPage(-1));
      nextEl.addEventListener('click', () => scrollByPage(1));
      mobileSliderEl.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anu-coupons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-anu-coupons]').forEach((sectionEl) => {
      const statusEl = sectionEl.querySelector('[data-anu-coupons-status]');

      sectionEl.querySelectorAll('[data-anu-coupons-copy]').forEach((buttonEl) => {
        buttonEl.addEventListener('click', async () => {
          const code = buttonEl.getAttribute('data-code') || '';
          const defaultLabel = buttonEl.getAttribute('data-label') || 'Copy';

          if (!code) {
            return;
          }

          try {
            await navigator.clipboard.writeText(code);
          } catch (error) {
            const inputEl = document.createElement('input');
            inputEl.value = code;
            inputEl.setAttribute('readonly', '');
            inputEl.style.position = 'fixed';
            inputEl.style.opacity = '0';
            document.body.appendChild(inputEl);
            inputEl.select();
            document.execCommand('copy');
            inputEl.remove();
          }
          const copiedText = buttonEl.getAttribute('data-copied-text') || 'Copied';
          buttonEl.textContent = copiedText;
          buttonEl.classList.add('is-copied');
          if (statusEl) {
            statusEl.textContent = `${code} copied`;
          }

          window.clearTimeout(buttonEl._anuCouponsTimer);
          buttonEl._anuCouponsTimer = window.setTimeout(() => {
            buttonEl.classList.remove('is-copied');
            buttonEl.textContent = defaultLabel;
          }, 1600);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anu-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.anu-faq').forEach((sectionEl) => {
      sectionEl.querySelectorAll('[data-anu-faq-item]').forEach((itemEl) => {
        const buttonEl = itemEl.querySelector('.anu-faq__button');
        const panelEl = itemEl.querySelector('.anu-faq__answer-panel');

        if (!buttonEl || !panelEl) {
          return;
        }

        const setPanelHeight = () => {
          panelEl.style.setProperty('--anu-faq-answer-height', `${panelEl.scrollHeight}px`);
        };

        setPanelHeight();

        buttonEl.addEventListener('click', () => {
          const shouldOpen = !itemEl.classList.contains('is-open');

          setPanelHeight();
          itemEl.classList.toggle('is-open', shouldOpen);
          buttonEl.setAttribute('aria-expanded', String(shouldOpen));
          panelEl.setAttribute('aria-hidden', String(!shouldOpen));
        });

        window.addEventListener('resize', setPanelHeight);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anu-logo-trusted"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const initializeTrustedLogos = (sectionEl) => {
      const trackEl = sectionEl.querySelector('[data-anu-logo-trusted-track]');
      const groupEl = sectionEl.querySelector('[data-anu-logo-trusted-group]');
      const viewportEl = sectionEl.querySelector('.anu-logo-trusted__viewport');

      if (!trackEl || !groupEl || !viewportEl) {
        return;
      }

      trackEl.classList.remove('is-ready');
      trackEl.style.removeProperty('--anu-logo-trusted-distance');
      trackEl.style.removeProperty('--anu-logo-trusted-duration');
      trackEl.querySelectorAll('[data-anu-logo-trusted-group-clone]').forEach((cloneEl) => cloneEl.remove());

      const groupWidth = groupEl.getBoundingClientRect().width;
      const viewportWidth = viewportEl.getBoundingClientRect().width;

      if (groupWidth <= 0 || viewportWidth <= 0) {
        return;
      }

      const createClone = () => {
        const cloneEl = groupEl.cloneNode(true);
        cloneEl.setAttribute('data-anu-logo-trusted-group-clone', '');
        cloneEl.setAttribute('aria-hidden', 'true');
        cloneEl.querySelectorAll('[data-shopify-editor-block]').forEach((itemEl) => itemEl.removeAttribute('data-shopify-editor-block'));
        trackEl.appendChild(cloneEl);
        return cloneEl;
      };

      const firstCloneEl = createClone();
      const loopDistance = firstCloneEl.offsetLeft - groupEl.offsetLeft;

      if (loopDistance <= 0) {
        return;
      }

      const targetWidth = viewportWidth * 2 + loopDistance;
      while (trackEl.scrollWidth < targetWidth) {
        createClone();
      }

      const duration = Math.max(18, Math.round(loopDistance / 70));
      trackEl.style.setProperty('--anu-logo-trusted-distance', `${loopDistance}px`);
      trackEl.style.setProperty('--anu-logo-trusted-duration', `${duration}s`);
      trackEl.classList.add('is-ready');
    };

    document.querySelectorAll('[data-anu-logo-trusted]').forEach((sectionEl) => {
      initializeTrustedLogos(sectionEl);

      let resizeTimer = null;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => initializeTrustedLogos(sectionEl), 150);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anu-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cssEscape = window.CSS && CSS.escape ? CSS.escape : (value) => value.replace(/[^a-zA-Z0-9_-]/g, '\\$&');

    const getTarget = (targetId) => {
      const cleanId = (targetId || '').trim().replace(/^#/, '');

      if (!cleanId) {
        return null;
      }

      return (
        document.getElementById(cleanId) ||
        document.getElementById(`shopify-section-${cleanId}`) ||
        document.querySelector(`[data-anchor-id="${cssEscape(cleanId)}"]`) ||
        document.querySelector(`[data-section-id="${cssEscape(cleanId)}"]`)
      );
    };

    document.querySelectorAll('[data-anu-nav]').forEach((sectionEl) => {
      const scrollerEl = sectionEl.querySelector('[data-anu-nav-scroller]');
      const navItems = Array.from(sectionEl.querySelectorAll('[data-anu-nav-link]')).map((linkEl) => ({
        linkEl,
        targetId: linkEl.getAttribute('data-target-id') || '',
        targetEl: null,
      }));
      let lockedItem = null;

      const refreshTargets = () => {
        navItems.forEach((item) => {
          item.targetEl = getTarget(item.targetId);
        });
      };

      const getOffset = () => {
        const sectionWrapper = sectionEl.closest('.shopify-section') || sectionEl.parentElement || sectionEl;
        const stickyTop = Number.parseFloat(window.getComputedStyle(sectionWrapper).top) || 0;

        return sectionEl.getBoundingClientRect().height + stickyTop;
      };

      const scrollActiveIntoView = (activeLink, behavior = 'smooth') => {
        if (!scrollerEl || !activeLink || scrollerEl.scrollWidth <= scrollerEl.clientWidth) {
          return;
        }

        const scrollerRect = scrollerEl.getBoundingClientRect();
        const activeRect = activeLink.getBoundingClientRect();
        const activeCenter = activeRect.left - scrollerRect.left + activeRect.width / 2;
        const scrollerCenter = scrollerEl.clientWidth / 2;
        const maxScrollLeft = scrollerEl.scrollWidth - scrollerEl.clientWidth;
        const nextScrollLeft = Math.max(0, Math.min(scrollerEl.scrollLeft + activeCenter - scrollerCenter, maxScrollLeft));

        if (Math.abs(nextScrollLeft - scrollerEl.scrollLeft) < 1) {
          return;
        }

        scrollerEl.scrollTo({
          left: nextScrollLeft,
          behavior,
        });
      };

      const setActive = (activeLink, behavior = 'smooth') => {
        if (!activeLink) {
          return;
        }

        if (activeLink.classList.contains('is-active')) {
          scrollActiveIntoView(activeLink, behavior);
          return;
        }

        navItems.forEach((item) => {
          item.linkEl.classList.remove('is-active');
          item.linkEl.removeAttribute('aria-current');
        });

        activeLink.classList.add('is-active');
        activeLink.setAttribute('aria-current', 'true');
        scrollActiveIntoView(activeLink, behavior);
      };

      const clearLock = () => {
        lockedItem = null;
      };

      const lockActive = (item) => {
        lockedItem = item;
      };

      const updateActive = () => {
        if (lockedItem) {
          setActive(lockedItem.linkEl);
          return;
        }

        const offset = getOffset() + 1;
        let activeItem = null;
        let closestPastItem = null;
        let closestPastDistance = Infinity;
        let closestFutureItem = null;
        let closestFutureDistance = Infinity;

        navItems.forEach((item) => {
          if (!item.targetEl) {
            item.targetEl = getTarget(item.targetId);
          }

          if (!item.targetEl) {
            return;
          }

          const rect = item.targetEl.getBoundingClientRect();

          if (rect.top <= offset && rect.bottom > offset) {
            activeItem = item;
            return;
          }

          const distance = rect.top - offset;

          if (distance <= 0 && Math.abs(distance) < closestPastDistance) {
            closestPastDistance = Math.abs(distance);
            closestPastItem = item;
          }

          if (distance > 0 && distance < closestFutureDistance) {
            closestFutureDistance = distance;
            closestFutureItem = item;
          }
        });

        const nextActiveItem = activeItem || closestPastItem || closestFutureItem;

        if (nextActiveItem) {
          setActive(nextActiveItem.linkEl);
        }
      };

      let ticking = false;
      const requestUpdate = () => {
        if (ticking) {
          return;
        }

        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          updateActive();
        });
      };

      navItems.forEach((item) => {
        item.linkEl.addEventListener('click', (event) => {
          refreshTargets();

          if (!item.targetEl) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          const top = Math.max(0, item.targetEl.getBoundingClientRect().top + window.scrollY - getOffset());

          setActive(item.linkEl);
          lockActive(item);
          item.linkEl.blur();

          window.scrollTo({
            top,
            behavior: 'smooth',
          });
        });
      });

      window.addEventListener('wheel', clearLock, { passive: true });
      window.addEventListener('touchstart', (event) => {
        if (!sectionEl.contains(event.target)) {
          clearLock();
        }
      }, { passive: true });
      window.addEventListener('keydown', (event) => {
        if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) {
          clearLock();
        }
      });

      refreshTargets();
      updateActive();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-banner"] && !Shopify.designMode) return;
  try {
    
  const defineCompareBannerCarousel = () => {
    if (customElements.get('compare-banner-carousel')) return;

    class CompareBannerCarousel extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.compare-banner');
        this.progressTarget = this.querySelector('[data-progress-target]');
        this.track = this.querySelector('[data-track]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.status = this.querySelector('[data-status]');
        this.interval = Number(this.dataset.interval) || 5000;
        this.itemCount = Number(this.dataset.blockCount) || 0;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 48rem)');
        this.controller = new AbortController();
        this.activeIndex = 0;
        this.userPaused = false;
        this.interactionPaused = false;
        this.keyboardFocusWithin = false;
        this.pendingAnnouncement = false;
        this.focusAfterChange = false;
        this.remainingTime = this.interval;
        this.startedAt = null;
        this.animationFrame = null;
        this.transitionTimer = null;
        this.isAnimating = false;
        if (!this.root || !this.track || !this.itemCount) return;

        for (const clone of this.querySelectorAll('[data-clone]')) clone.remove();
        this.originalSlides = [...this.querySelectorAll('.compare-banner__slide')];
        this.originalItems = this.originalSlides.map((slide) => slide.querySelector('.compare-banner__item'));
        this.cloneCount = this.itemCount > 1 ? Math.min(2, this.itemCount) : 0;
        this.#createClones();
        this.slides = [...this.querySelectorAll('.compare-banner__slide')];
        this.items = [...this.querySelectorAll('.compare-banner__item')];
        this.sequenceIndex = this.cloneCount;
        this.#bindEvents();
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            if (!this.isAnimating) this.#setTrackPosition(false);
          });
          this.resizeObserver.observe(this.track.parentElement);
        }
        this.#setTrackPosition(false);
        this.#syncActive(true);
        this.#restartAutoplay();
      }

      disconnectedCallback() {
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        if (this.transitionTimer) clearTimeout(this.transitionTimer);
        this.resizeObserver?.disconnect();
        this.controller?.abort();
      }

      #createClones() {
        if (!this.cloneCount) return;

        const prepareClone = (slide) => {
          const clone = slide.cloneNode(true);
          clone.dataset.clone = 'true';
          clone.setAttribute('aria-hidden', 'true');

          for (const element of [clone, ...clone.querySelectorAll('*')]) {
            element.removeAttribute('id');
            element.removeAttribute('data-block-id');
            for (const attribute of [...element.attributes]) {
              if (attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
            }
          }

          const item = clone.querySelector('.compare-banner__item');
          if (item) {
            const visualItem = document.createElement('span');
            visualItem.className = item.className;
            visualItem.classList.remove('is-active');
            for (const [key, value] of Object.entries(item.dataset)) visualItem.dataset[key] = value;
            visualItem.innerHTML = item.innerHTML;
            item.replaceWith(visualItem);
          }
          return clone;
        };

        const before = this.originalSlides.slice(-this.cloneCount).map(prepareClone);
        const after = this.originalSlides.slice(0, this.cloneCount).map(prepareClone);
        this.track.prepend(...before);
        this.track.append(...after);
      }

      #bindEvents() {
        const { signal } = this.controller;

        for (const item of this.items) {
          item.addEventListener(
            'click',
            () => {
              const slide = item.closest('.compare-banner__slide');
              const sequenceIndex = this.slides.indexOf(slide);
              if (sequenceIndex >= 0) this.#goToSequence(sequenceIndex, true);
              window.compareHashVisibilityController?.selectHash?.(
                item.dataset.compareHash,
                false,
                document.querySelector('[data-compare-bar]')
              );
            },
            { signal }
          );
          item.addEventListener('keydown', (event) => this.#handleKeydown(event), { signal });
          if (item.closest('[data-clone]')) {
            item.addEventListener('pointerdown', (event) => event.preventDefault(), { signal });
          }
        }

        this.pauseButton?.addEventListener('click', () => this.#toggleUserPause(), { signal });
        this.track.addEventListener(
          'transitionend',
          (event) => {
            if (event.target === this.track && event.propertyName === 'transform') this.#finishTransition();
          },
          { signal }
        );

        this.addEventListener(
          'focusin',
          (event) => {
            if (!event.target.matches(':focus-visible')) return;
            this.keyboardFocusWithin = true;
            this.#pauseForInteraction();
          },
          { signal }
        );
        this.addEventListener(
          'focusout',
          (event) => {
            if (this.contains(event.relatedTarget)) return;
            this.keyboardFocusWithin = false;
            this.#resumeFromInteraction();
          },
          { signal }
        );

        this.addEventListener(
          'shopify:block:select',
          (event) => {
            const selected = event.target.closest('[data-block-id]');
            if (!selected) return;
            const index = Number(selected.dataset.index);
            if (Number.isInteger(index)) this.#goToBlock(index, true);
          },
          { signal }
        );

        this.motionQuery.addEventListener('change', () => this.#handleMotionChange(), { signal });
        window.addEventListener('resize', () => this.#handleResize(), { signal });
      }

      #handleKeydown(event) {
        if (this.isAnimating) return;

        const nextKey = this.mobileQuery.matches ? 'ArrowRight' : 'ArrowDown';
        const previousKey = this.mobileQuery.matches ? 'ArrowLeft' : 'ArrowUp';
        if (![nextKey, previousKey, 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        this.pendingAnnouncement = true;
        this.focusAfterChange = true;

        if (event.key === 'Home') {
          this.#goToBlock(0, true);
          return;
        }
        if (event.key === 'End') {
          this.#goToBlock(this.itemCount - 1, true);
          return;
        }

        if (event.key === nextKey) this.#goToSequence(this.sequenceIndex + 1, true);
        if (event.key === previousKey) this.#goToSequence(this.sequenceIndex - 1, true);
      }

      #goToBlock(index, announce) {
        if (index < 0 || index >= this.itemCount) return;

        const target = this.slides.reduce((nearest, slide, sequenceIndex) => {
          if (Number(slide.dataset.index) !== index) return nearest;
          if (nearest === -1) return sequenceIndex;
          return Math.abs(sequenceIndex - this.sequenceIndex) < Math.abs(nearest - this.sequenceIndex)
            ? sequenceIndex
            : nearest;
        }, -1);

        if (target >= 0) this.#goToSequence(target, announce);
      }

      #goToSequence(sequenceIndex, announce) {
        if (this.isAnimating || sequenceIndex < 0 || sequenceIndex >= this.slides.length) return;

        this.pendingAnnouncement = announce;
        if (sequenceIndex === this.sequenceIndex) {
          this.#syncActive(true);
          this.#restartAutoplay();
          return;
        }

        this.sequenceIndex = sequenceIndex;
        this.activeIndex = Number(this.slides[this.sequenceIndex].dataset.index);
        const animate = !this.motionQuery.matches;
        this.isAnimating = animate;
        this.#syncActive(false);
        this.#setTrackPosition(animate);
        this.#restartAutoplay();

        if (animate) {
          if (this.transitionTimer) clearTimeout(this.transitionTimer);
          this.transitionTimer = setTimeout(() => this.#finishTransition(), 650);
        } else {
          this.#finishTransition();
        }
      }

      #setTrackPosition(animate) {
        const referenceSlide = this.slides[0];
        if (!referenceSlide) return;

        const isMobile = this.mobileQuery.matches;
        const slideSize = isMobile ? referenceSlide.getBoundingClientRect().width : referenceSlide.offsetHeight;
        const gap = isMobile ? 16 : 8;
        const offset = (1 - this.sequenceIndex) * (slideSize + gap);

        if (!animate) this.track.style.transition = 'none';
        this.track.style.transform = isMobile
          ? `translate3d(${offset}px, 0, 0)`
          : `translate3d(0, ${offset}px, 0)`;

        if (!animate) {
          this.track.getBoundingClientRect();
          this.track.style.removeProperty('transition');
        }
      }

      #finishTransition() {
        if (this.transitionTimer) clearTimeout(this.transitionTimer);
        this.transitionTimer = null;

        const firstOriginal = this.cloneCount;
        const afterOriginals = this.cloneCount + this.itemCount;
        if (this.sequenceIndex < firstOriginal) this.sequenceIndex += this.itemCount;
        if (this.sequenceIndex >= afterOriginals) this.sequenceIndex -= this.itemCount;

        this.activeIndex = Number(this.slides[this.sequenceIndex].dataset.index);
        this.#setTrackPosition(false);
        this.isAnimating = false;
        this.#syncActive(true);
      }

      #syncActive(allowFocus) {
        const activeSlide = this.slides[this.sequenceIndex];
        if (!activeSlide) return;

        for (const item of this.items) {
          const slide = item.closest('.compare-banner__slide');
          const active = Number(item.dataset.index) === this.activeIndex;
          const physicallyActive = slide === activeSlide;
          const isClone = slide.hasAttribute('data-clone');
          item.classList.toggle('is-active', active);
          if (!isClone) item.setAttribute('aria-pressed', String(active));
          item.tabIndex = physicallyActive && !isClone ? 0 : -1;
        }

        for (const [sequenceIndex, slide] of this.slides.entries()) {
          const hidden = slide.hasAttribute('data-clone') || Math.abs(sequenceIndex - this.sequenceIndex) > 1;
          slide.setAttribute('aria-hidden', String(hidden));
        }

        const activeItem = activeSlide.querySelector('.compare-banner__item');
        if (this.pendingAnnouncement && this.status && activeItem) {
          const textSelector = this.mobileQuery.matches
            ? '.compare-banner__item-text--mobile'
            : '.compare-banner__item-text--desktop';
          this.status.textContent = activeItem.querySelector(textSelector)?.textContent.trim() || '';
          this.pendingAnnouncement = false;
        }

        const focusTarget = this.originalItems[this.activeIndex];
        if (this.focusAfterChange && allowFocus && focusTarget) {
          focusTarget.focus({ preventScroll: true });
          this.focusAfterChange = false;
        }
      }

      #handleResize() {
        if (this.isAnimating) this.#finishTransition();
        else this.#setTrackPosition(false);
      }

      #pauseForInteraction() {
        if (this.interactionPaused) return;
        this.interactionPaused = true;
        this.#pauseAutoplay();
      }

      #resumeFromInteraction() {
        if (!this.interactionPaused) return;
        this.interactionPaused = false;
        this.#resumeAutoplay();
      }

      #pauseAutoplay() {
        if (this.startedAt !== null) {
          const elapsed = performance.now() - this.startedAt;
          this.remainingTime = Math.max(0, this.remainingTime - elapsed);
        }
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.startedAt = null;
        this.root.dataset.paused = 'true';
      }

      #resumeAutoplay() {
        if (this.itemCount <= 1 || this.motionQuery.matches || this.userPaused || this.interactionPaused) return;
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        if (this.remainingTime <= 0) this.remainingTime = this.interval;
        this.startedAt = performance.now();
        this.animationFrame = requestAnimationFrame((time) => this.#tickAutoplay(time));
        this.root.dataset.paused = 'false';
      }

      #restartAutoplay() {
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.startedAt = null;
        this.remainingTime = this.interval;
        this.progressTarget?.style.setProperty('--progress', '0');

        if (this.itemCount <= 1 || this.motionQuery.matches || this.userPaused || this.interactionPaused) {
          this.root.dataset.paused = 'true';
          return;
        }

        this.#resumeAutoplay();
      }

      #tickAutoplay(time) {
        if (this.startedAt === null) return;

        const elapsed = time - this.startedAt;
        const totalElapsed = this.interval - this.remainingTime + elapsed;
        const progress = Math.min(totalElapsed / this.interval, 1);
        this.progressTarget?.style.setProperty('--progress', String(progress));

        if (elapsed >= this.remainingTime) {
          this.animationFrame = null;
          this.startedAt = null;
          this.remainingTime = this.interval;
          this.#goToBlock((this.activeIndex + 1) % this.itemCount, false);
          return;
        }

        this.animationFrame = requestAnimationFrame((nextTime) => this.#tickAutoplay(nextTime));
      }

      #toggleUserPause() {
        this.userPaused = !this.userPaused;
        this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
        this.pauseButton.textContent = this.userPaused ? 'Play comparison rotation' : 'Pause comparison rotation';
        if (this.userPaused) this.#pauseAutoplay();
        else this.#resumeAutoplay();
      }

      #handleMotionChange() {
        if (this.motionQuery.matches) {
          this.#pauseAutoplay();
          this.remainingTime = this.interval;
          return;
        }

        this.#restartAutoplay();
      }
    }

    customElements.define('compare-banner-carousel', CompareBannerCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', defineCompareBannerCarousel, { once: true });
  } else {
    defineCompareBannerCarousel();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllerKey = 'compareHashVisibilityController';
    const editorPreviewHashKey = 'compareBarEditorPreviewHash';

    if (typeof window[controllerKey]?.previewHash === 'function') {
      window[controllerKey].initialize();
      return;
    }

    const normalizeHash = (value) => {
      const hash = String(value || '')
        .trim()
        .replace(/^#+/, '');

      try {
        return decodeURIComponent(hash);
      } catch {
        return hash;
      }
    };

    const currentHash = () => {
      if (Object.prototype.hasOwnProperty.call(window, editorPreviewHashKey)) {
        return normalizeHash(window[editorPreviewHashKey]);
      }

      const hashFromUrl = normalizeHash(window.location.hash);
      if (hashFromUrl !== '') return hashFromUrl;

      const firstItem = document.querySelector('[data-compare-bar] [data-compare-bar-item]');
      return normalizeHash(firstItem?.dataset.compareHash);
    };

    const updateMainBackground = (color) => {
      const normalizedColor = String(color || '').trim();

      for (const mainElement of document.querySelectorAll('[role="main"]')) {
        if (normalizedColor === '') {
          mainElement.style.removeProperty('--compare-main-background');
          mainElement.removeAttribute('data-compare-main-background');
          continue;
        }

        mainElement.style.setProperty('--compare-main-background', normalizedColor);
        mainElement.setAttribute('data-compare-main-background', '');
      }
    };

    const ensureActiveItemVisible = (item) => {
      const bar = item?.closest('[data-compare-bar]');
      if (!bar || !window.matchMedia('(max-width: 48rem)').matches) return;

      requestAnimationFrame(() => {
        const barRect = bar.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const padding = 16;
        let targetLeft = null;

        if (itemRect.left < barRect.left + padding) {
          targetLeft = bar.scrollLeft - (barRect.left + padding - itemRect.left);
        } else if (itemRect.right > barRect.right - padding) {
          targetLeft = bar.scrollLeft + (itemRect.right - (barRect.right - padding));
        }

        if (targetLeft === null) return;

        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const maxScroll = Math.max(0, bar.scrollWidth - bar.clientWidth);
        bar.scrollTo({ left: Math.min(Math.max(targetLeft, 0), maxScroll), behavior });
      });
    };

    const updateBarState = (hash) => {
      let activeItem = null;

      for (const bar of document.querySelectorAll('[data-compare-bar]')) {
        const items = [...bar.querySelectorAll('[data-compare-bar-item]')];
        let activeItemFound = false;
        let activeBarItem = null;

        for (const item of items) {
          const isActive = !activeItemFound && normalizeHash(item.dataset.compareHash) === hash;
          item.classList.toggle('compare-bar__item--mobile-active', isActive);
          item.classList.toggle('compare-bar__item--desktop-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
          if (isActive) {
            activeItemFound = true;
            activeBarItem = item;
            if (!activeItem) activeItem = item;
          }
        }

        ensureActiveItemVisible(activeBarItem);
      }

      updateMainBackground(activeItem?.dataset.mainBgColor);
    };

    const scrollToFirstVisibleSection = (sourceBar) => {
      if (!sourceBar) return;

      const sourceSection = sourceBar.closest('.shopify-section');
      const mainElement = sourceBar.closest('[role="main"]') || document.querySelector('[role="main"]');
      if (!mainElement) return;

      const visibleComponents = mainElement.querySelectorAll('[data-visible-in-hash]:not([hidden])');
      let targetSection = null;

      for (const component of visibleComponents) {
        const candidateSection = component.closest('.shopify-section') || component;
        const isAfterBar = Boolean(
          sourceBar.compareDocumentPosition(component) & Node.DOCUMENT_POSITION_FOLLOWING
        );

        if (!isAfterBar || candidateSection === sourceSection || component.getClientRects().length === 0) continue;

        targetSection = candidateSection;
        break;
      }

      if (!targetSection) return;

      requestAnimationFrame(() => {
        const targetTop = targetSection.getBoundingClientRect().top + window.scrollY;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        window.scrollTo({ top: targetTop, behavior });
      });
    };

    const refreshVisibleComponents = () => {
      const hash = currentHash();

      for (const component of document.querySelectorAll('[data-visible-in-hash]')) {
        const componentHash = normalizeHash(component.dataset.visibleInHash);
        const shouldShow = componentHash === '' || componentHash === hash;
        component.hidden = !shouldShow;

        if (!shouldShow) {
          for (const video of component.querySelectorAll('video')) video.pause();
        }
      }

      updateBarState(hash);

      requestAnimationFrame(() => {
        for (const swiperElement of document.querySelectorAll('[data-visible-in-hash]:not([hidden]) .swiper')) {
          swiperElement.swiper?.update();
        }

        document.dispatchEvent(
          new CustomEvent('compare:hash-change', {
            detail: { hash },
          })
        );
      });
    };

    const selectHash = (hash, replaceCurrentHistoryEntry = false, sourceBar = null) => {
      const normalizedHash = normalizeHash(hash);
      const url = new URL(window.location.href);
      url.hash = normalizedHash;
      delete window[editorPreviewHashKey];

      if (normalizeHash(window.location.hash) !== normalizedHash) {
        const historyMethod = replaceCurrentHistoryEntry ? 'replaceState' : 'pushState';
        window.history[historyMethod]({}, '', url);
      }

      refreshVisibleComponents();
      scrollToFirstVisibleSection(sourceBar);
    };

    const previewHash = (hash) => {
      window[editorPreviewHashKey] = normalizeHash(hash);
      refreshVisibleComponents();
    };

    const bindBars = () => {
      for (const item of document.querySelectorAll('[data-compare-bar-item]')) {
        if (item.dataset.compareHashBound === 'true') continue;

        item.addEventListener('click', () => {
          const sourceBar = item.closest('[data-compare-bar]');
          selectHash(item.dataset.compareHash, false, sourceBar);
        });
        item.dataset.compareHashBound = 'true';
      }
    };

    const initialize = () => {
      bindBars();
      refreshVisibleComponents();
    };

    window[controllerKey] = { initialize, previewHash, selectHash };
    window.addEventListener('hashchange', refreshVisibleComponents);
    window.addEventListener('popstate', refreshVisibleComponents);
    document.addEventListener('shopify:section:load', initialize);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-colors"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-e3-ultra-colors]');

    for (const section of sections) {
      const panels = [...section.querySelectorAll('[data-color-panel]')];
      const colorButtons = [...section.querySelectorAll('[data-color-button]')];
      const previousButton = section.querySelector('[data-color-previous]');
      const nextButton = section.querySelector('[data-color-next]');
      const slideGap = parseFloat(getComputedStyle(section).getPropertyValue('--e3-colors-slide-gap')) || 12;
      const swipers = panels.map(
        (panel) =>
          new Swiper(panel, {
            slidesPerView: 'auto',
            spaceBetween: slideGap,
            loop: false,
            observer: true,
            observeParents: true,
            watchOverflow: true,
            speed: 400,
            a11y: false,
          })
      );
      let activeColorIndex = 0;

      const syncSlideState = (swiper) => {
        for (const [index, slide] of swiper.slides.entries()) {
          const isActive = index === swiper.activeIndex;
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.inert = !isActive;
        }
      };

      const syncNavigationState = (swiper) => {
        if (swiper !== swipers[activeColorIndex]) return;
        const hasMultipleSlides = swiper.slides.length > 1;
        if (previousButton) previousButton.disabled = !hasMultipleSlides || swiper.isBeginning;
        if (nextButton) nextButton.disabled = !hasMultipleSlides || swiper.isEnd;
      };

      const renderColor = (index) => {
        activeColorIndex = index;
        const activeSwiper = swipers[activeColorIndex];

        for (const [panelIndex, panel] of panels.entries()) {
          panel.hidden = panelIndex !== activeColorIndex;
        }

        for (const [buttonIndex, button] of colorButtons.entries()) {
          const isSelected = buttonIndex === activeColorIndex;
          button.setAttribute('aria-selected', String(isSelected));
          button.tabIndex = isSelected ? 0 : -1;
        }

        activeSwiper.update();
        activeSwiper.slideTo(0, 0);
        syncSlideState(activeSwiper);
        syncNavigationState(activeSwiper);
      };

      for (const [index, button] of colorButtons.entries()) {
        button.addEventListener('click', () => {
          renderColor(index);
        });

        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + colorButtons.length) % colorButtons.length;
          colorButtons[nextIndex]?.focus();
          colorButtons[nextIndex]?.click();
        });
      }

      previousButton?.addEventListener('click', () => {
        swipers[activeColorIndex].slidePrev();
      });

      nextButton?.addEventListener('click', () => {
        swipers[activeColorIndex].slideNext();
      });

      for (const swiper of swipers) {
        swiper.on('slideChange', () => {
          syncSlideState(swiper);
          syncNavigationState(swiper);
        });
      }

      renderColor(0);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-comparison"] && !Shopify.designMode) return;
  try {
    
  const e3TableScrollbars = new WeakMap();

  function initE3TableScrollbars(container = document) {
    for (const section of container.querySelectorAll('.e3-ultra-table')) {
      if (e3TableScrollbars.has(section)) continue;
      const scroll = section.querySelector('[data-table-scroll]');
      const bar = section.querySelector('[data-table-scrollbar]');
      const thumb = section.querySelector('[data-table-scrollbar-thumb]');
      if (!scroll || !bar || !thumb) continue;

      function update() {
        const trackWidth = bar.clientWidth;
        const maxScroll = scroll.scrollWidth - scroll.clientWidth;
        if (!trackWidth || maxScroll <= 0) return;
        const thumbWidth = Math.max(24, trackWidth * scroll.clientWidth / scroll.scrollWidth);
        const travel = trackWidth - thumbWidth;
        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${travel * scroll.scrollLeft / maxScroll}px)`;
      }

      function moveToPointer(event) {
        const rect = bar.getBoundingClientRect();
        const thumbWidth = thumb.getBoundingClientRect().width;
        const travel = rect.width - thumbWidth;
        if (travel <= 0) return;
        const position = Math.max(0, Math.min(travel, event.clientX - rect.left - thumbWidth / 2));
        scroll.scrollLeft = position / travel * (scroll.scrollWidth - scroll.clientWidth);
      }

      function onPointerDown(event) {
        bar.setPointerCapture(event.pointerId);
        moveToPointer(event);
      }

      function onPointerMove(event) {
        if (bar.hasPointerCapture(event.pointerId)) moveToPointer(event);
      }

      section.classList.add('e3-ultra-table--scrollbar-ready');
      scroll.addEventListener('scroll', update, { passive: true });
      bar.addEventListener('pointerdown', onPointerDown);
      bar.addEventListener('pointermove', onPointerMove);
      window.addEventListener('resize', update);
      update();

      e3TableScrollbars.set(section, () => {
        scroll.removeEventListener('scroll', update);
        bar.removeEventListener('pointerdown', onPointerDown);
        bar.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('resize', update);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initE3TableScrollbars(), { once: true });
  } else {
    initE3TableScrollbars();
  }
  document.addEventListener('shopify:section:load', (event) => initE3TableScrollbars(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const section of event.target.querySelectorAll('.e3-ultra-table')) {
      e3TableScrollbars.get(section)?.();
      e3TableScrollbars.delete(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-feature"] && !Shopify.designMode) return;
  try {
    
  const initE3UltraFeatures = (root = document) => {
    for (const section of root.querySelectorAll('.e3-ultra-feature')) {
      if (section.dataset.featureInitialized === 'true') continue;
      section.dataset.featureInitialized = 'true';

      const cards = [...section.querySelectorAll('.e3-ultra-feature__card')];
      const mediaQuery = window.matchMedia('(max-width: 768px)');
      let inView = false;

      const syncVideos = () => {
        for (const card of cards) {
          const videos = [...card.querySelectorAll('video')];
          const activeVideo = videos.find((video) => getComputedStyle(video).display !== 'none');

          for (const video of videos) {
            if (video === activeVideo && inView && !document.hidden) {
              if (!video.paused) continue;
              video.play().catch(() => {});
            } else if (!video.paused) {
              video.pause();
            }
          }
        }
      };

      const observer = new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
        syncVideos();
      }, { threshold: 0 });

      observer.observe(section);
      mediaQuery.addEventListener('change', syncVideos);
      document.addEventListener('visibilitychange', syncVideos);
      const onSectionUnload = (event) => {
        if (!event.target.contains(section)) return;
        observer.disconnect();
        mediaQuery.removeEventListener('change', syncVideos);
        document.removeEventListener('visibilitychange', syncVideos);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        for (const video of section.querySelectorAll('video')) video.pause();
      };
      document.addEventListener('shopify:section:unload', onSectionUnload);
    }
  };

  document.addEventListener('DOMContentLoaded', () => initE3UltraFeatures());
  if (document.readyState !== 'loading') initE3UltraFeatures();
  document.addEventListener('shopify:section:load', (event) => initE3UltraFeatures(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-highlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.e3-ultra-highlight';
    const mobileQuery = window.matchMedia('(max-width: 768px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initHighlight(root) {
      if (root.dataset.highlightReady === 'true') return;
      const track = root.querySelector('.e3-ultra-highlight__swiper');
      if (!track) return;

      root.dataset.highlightReady = 'true';
      const wrapper = track.querySelector('.e3-ultra-highlight__grid');
      const originalSlides = [...wrapper.children];
      let swiper = null;

      function setOpen(card, open) {
        const toggle = card.querySelector('.e3-ultra-highlight__toggle');
        const detail = card.querySelector('.e3-ultra-highlight__detail');
        const front = card.querySelector('.e3-ultra-highlight__front');
        if (!toggle || !detail) return;
        card.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', `${open ? root.dataset.closeLabel : root.dataset.openLabel}: ${toggle.dataset.cardTitle}`);
        detail.setAttribute('aria-hidden', String(!open));
        front.setAttribute('aria-hidden', String(open));
      }

      function closeAll() {
        for (const card of originalSlides) setOpen(card, false);
      }

      function syncVideos(activeCard) {
        for (const card of originalSlides) {
          const video = card.querySelector('video');
          if (!video) continue;

          const media = video.closest('.e3-ultra-highlight__media');
          const poster = mobileQuery.matches ? media.dataset.posterMobile : media.dataset.posterDesktop;
          if (poster && video.getAttribute('poster') !== poster) video.poster = poster;

          const shouldPlay = !reducedMotionQuery.matches && (!mobileQuery.matches || card === activeCard);
          if (shouldPlay && video.paused) video.play().catch(() => {});
          if (!shouldPlay && !video.paused) video.pause();
        }
      }

      function syncSlider() {
        if (mobileQuery.matches && !swiper) {
          const mobileSlides = [...originalSlides].sort((a, b) => Number(a.dataset.mobilePosition) - Number(b.dataset.mobilePosition));
          for (const card of mobileSlides) wrapper.append(card);
          swiper = new Swiper(track, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            watchOverflow: true,
            keyboard: { enabled: true, onlyInViewport: true },
            a11y: { enabled: true },
            navigation: {
              prevEl: root.querySelector('.e3-ultra-highlight__arrow--prev'),
              nextEl: root.querySelector('.e3-ultra-highlight__arrow--next')
            },
            on: {
              slideChangeTransitionStart(swiperInstance) {
                closeAll();
                syncVideos(swiperInstance.slides[swiperInstance.activeIndex]);
              }
            }
          });
        } else if (!mobileQuery.matches && swiper) {
          swiper.destroy(true, true);
          swiper = null;
          for (const card of originalSlides) wrapper.append(card);
          closeAll();
        }
        syncVideos(swiper ? swiper.slides[swiper.activeIndex] : null);
      }

      root.addEventListener('click', (event) => {
        const toggle = event.target.closest('.e3-ultra-highlight__toggle');
        if (!toggle || !root.contains(toggle)) return;
        const card = toggle.closest('.e3-ultra-highlight__card');
        const shouldOpen = !card.classList.contains('is-open');
        closeAll();
        if (shouldOpen) setOpen(card, true);
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeAll();
      });

      mobileQuery.addEventListener('change', syncSlider);
      reducedMotionQuery.addEventListener('change', syncSlider);
      root.highlightCleanup = () => {
        mobileQuery.removeEventListener('change', syncSlider);
        reducedMotionQuery.removeEventListener('change', syncSlider);
        if (swiper) swiper.destroy(true, true);
        for (const video of root.querySelectorAll('video')) video.pause();
      };
      syncSlider();
    }

    function initAll(scope = document) {
      if (scope.matches?.(selector)) initHighlight(scope);
      for (const root of scope.querySelectorAll(selector)) initHighlight(root);
    }

    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-learn-more"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.e3-learn';
    const openDuration = 350;
    const closeDuration = 250;

    function init(root) {
      if (root.dataset.e3LearnReady) return;
      root.dataset.e3LearnReady = 'true';
      const dialog = root.querySelector('.e3-learn__dialog');
      const cover = root.querySelector('.e3-learn__cover');
      const videos = cover.querySelectorAll('.e3-learn__cover-video');
      const openButton = root.querySelector('[data-e3-open]');
      const openTrigger = root.querySelector('[data-e3-open-trigger]');
      const closeButton = root.querySelector('[data-e3-close]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = window.matchMedia('(max-width: 768px)');
      let animation;
      let revealObserver;
      let closing = false;
      let overflowSnapshot;

      function finishButtonReveal() {
        revealObserver?.disconnect();
        root.classList.remove('e3-learn--reveal-pending', 'e3-learn--reveal-active');
      }

      function revealButton() {
        if (!root.classList.contains('e3-learn--reveal-pending')) return;
        revealObserver?.disconnect();
        root.classList.remove('e3-learn--reveal-pending');
        root.classList.add('e3-learn--reveal-active');
      }

      function onButtonAnimationEnd(event) {
        if (event.target === openButton && event.animationName === 'e3-learn-open-reveal') finishButtonReveal();
      }

      function onMotionChange() {
        if (reduceMotion.matches) finishButtonReveal();
        syncVideos();
      }

      function lockPageScroll() {
        if (overflowSnapshot) return;
        overflowSnapshot = [document.documentElement, document.body].map((element) => ({
          element,
          value: element.style.getPropertyValue('overflow'),
          priority: element.style.getPropertyPriority('overflow'),
        }));
        for (const { element } of overflowSnapshot) element.style.setProperty('overflow', 'hidden', 'important');
      }

      function unlockPageScroll() {
        if (!overflowSnapshot) return;
        for (const { element, value, priority } of overflowSnapshot) {
          if (value) element.style.setProperty('overflow', value, priority);
          else element.style.removeProperty('overflow');
        }
        overflowSnapshot = null;
      }

      function syncVideos() {
        for (const video of videos) {
          const active =
            getComputedStyle(video).display !== 'none' && !dialog.open && !reduceMotion.matches && !document.hidden;
          if (!active) {
            video.pause();
            continue;
          }
          if (video.classList.contains('e3-learn__cover-video--desktop')) {
            video.poster =
              (mobile.matches ? cover.dataset.posterMobile : cover.dataset.posterDesktop) ||
              cover.dataset.posterDesktop ||
              '';
          }
          if (video.paused) video.play().catch(() => {});
        }
      }

      function open() {
        if (dialog.open) return;
        finishButtonReveal();
        animation?.cancel();
        dialog.showModal();
        lockPageScroll();
        dialog.scrollTop = 0;
        closeButton.focus({ preventScroll: true });
        syncVideos();
        if (reduceMotion.matches) return;
        animation = dialog.animate([{ opacity: 0 }, { opacity: 1 }], { duration: openDuration, easing: 'ease-out' });
      }

      async function close() {
        if (!dialog.open || closing) return;
        closing = true;
        const currentOpacity = getComputedStyle(dialog).opacity;
        animation?.cancel();
        if (!reduceMotion.matches) {
          animation = dialog.animate([{ opacity: currentOpacity }, { opacity: 0 }], {
            duration: closeDuration,
            easing: 'ease-in',
            fill: 'forwards',
          });
          try {
            await animation.finished;
          } catch (error) {
            /* Interrupted by section removal. */
          }
        }
        if (dialog.open) dialog.close();
        animation?.cancel();
        animation = null;
        unlockPageScroll();
        openButton.focus({ preventScroll: true });
        closing = false;
        syncVideos();
      }

      function onCancel(event) {
        event.preventDefault();
        close();
      }

      openButton.addEventListener('click', open);
      openButton.addEventListener('focus', finishButtonReveal);
      openButton.addEventListener('animationend', onButtonAnimationEnd);
      closeButton.addEventListener('click', close);
      dialog.addEventListener('cancel', onCancel);
      mobile.addEventListener('change', syncVideos);
      reduceMotion.addEventListener('change', onMotionChange);
      document.addEventListener('visibilitychange', syncVideos);
      if (!reduceMotion.matches && 'IntersectionObserver' in window) {
        root.classList.add('e3-learn--reveal-pending');
        revealObserver = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.intersectionRatio >= 0.5)) revealButton();
          },
          { threshold: 0.5, rootMargin: '0px 0px -5% 0px' }
        );
        revealObserver.observe(openTrigger);
      }
      syncVideos();
      root.e3LearnCleanup = () => {
        animation?.cancel();
        finishButtonReveal();
        for (const video of videos) video.pause();
        if (dialog.open) dialog.close();
        unlockPageScroll();
        openButton.removeEventListener('click', open);
        openButton.removeEventListener('focus', finishButtonReveal);
        openButton.removeEventListener('animationend', onButtonAnimationEnd);
        closeButton.removeEventListener('click', close);
        dialog.removeEventListener('cancel', onCancel);
        mobile.removeEventListener('change', syncVideos);
        reduceMotion.removeEventListener('change', onMotionChange);
        document.removeEventListener('visibilitychange', syncVideos);
        delete root.dataset.e3LearnReady;
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(selector)) init(scope);
      for (const root of scope.querySelectorAll(selector)) init(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.(selector) ? event.target : event.target.querySelector(selector);
      root?.e3LearnCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-media"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-e3-ultra-media]';

    function init(root) {
      if (root.dataset.e3UltraMediaReady) return;
      root.dataset.e3UltraMediaReady = 'true';

      const preview = root.querySelector('.e3-ultra-media__preview-video');
      const dialog = root.querySelector('.e3-ultra-media__dialog');
      const popup = root.querySelector('video.e3-ultra-media__popup-video');
      const youtube = root.querySelector('[data-e3-ultra-media-youtube]');
      const openButton = root.querySelector('[data-e3-ultra-media-open]');
      const closeButton = root.querySelector('[data-e3-ultra-media-close]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let closeAnimation;
      let closing = false;
      let isVisible = true;
      let observer;

      function syncPreview() {
        if (!preview) return;
        if (document.hidden || !isVisible || dialog?.open || reducedMotion.matches) {
          preview.pause();
        } else if (preview.paused) {
          preview.play().catch(() => {});
        }
      }

      function open() {
        if (!dialog || dialog.open) return;
        closeAnimation?.cancel();
        dialog.showModal();
        preview?.pause();
        closeButton.focus({ preventScroll: true });
        if (youtube) {
          youtube.src = youtube.dataset.src;
        } else if (popup) {
          popup.currentTime = 0;
          popup.play().catch(() => {});
        }
        if (!reducedMotion.matches) {
          dialog.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
          root.querySelector('.e3-ultra-media__player')?.animate(
            [{ opacity: 0, transform: 'translateY(12px) scale(0.98)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }],
            { duration: 240, easing: 'ease-out' }
          );
        }
      }

      async function close() {
        if (!dialog?.open || closing) return;
        closing = true;
        popup?.pause();
        youtube?.removeAttribute('src');
        if (!reducedMotion.matches) {
          closeAnimation = dialog.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-in', fill: 'forwards' });
          try { await closeAnimation.finished; } catch (error) { /* Section may be removed during animation. */ }
        }
        if (dialog.open) dialog.close();
        closeAnimation?.cancel();
        closeAnimation = null;
        if (popup) popup.currentTime = 0;
        openButton?.focus({ preventScroll: true });
        closing = false;
        syncPreview();
      }

      openButton?.addEventListener('click', open, options);
      closeButton?.addEventListener('click', close, options);
      dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      }, options);
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      }, options);
      document.addEventListener('visibilitychange', syncPreview, options);
      reducedMotion.addEventListener('change', syncPreview, options);

      if (preview && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          isVisible = entries[0]?.isIntersecting ?? false;
          syncPreview();
        });
        observer.observe(root);
      }
      syncPreview();

      root.e3UltraMediaCleanup = () => {
        controller.abort();
        observer?.disconnect();
        closeAnimation?.cancel();
        preview?.pause();
        popup?.pause();
        youtube?.removeAttribute('src');
        if (dialog?.open) dialog.close();
        delete root.dataset.e3UltraMediaReady;
        delete root.e3UltraMediaCleanup;
      };
    }

    function initAll(scope = document) {
      if (scope.matches?.(selector)) init(scope);
      for (const root of scope.querySelectorAll(selector)) init(root);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.matches?.(selector)) event.target.e3UltraMediaCleanup?.();
      for (const root of event.target.querySelectorAll(selector)) root.e3UltraMediaCleanup?.();
    });
    if (document.readyState !== 'loading') initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-nav"] && !Shopify.designMode) return;
  try {
    
  class E3UltraNavigation {
    constructor(section) {
      this.section = section;
      this.links = [...section.querySelectorAll('.e3-ultra-nav__link[href^="#"]')];
      this.targets = this.links.map((link) => ({
        link,
        target: document.getElementById(decodeURIComponent(link.hash.slice(1)))
      })).filter(({ target }) => target);
      if (!this.targets.length) return;

      this.onClick = this.onClick.bind(this);
      this.section.addEventListener('click', this.onClick);
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }

    onClick(event) {
      const link = event.target.closest('.e3-ultra-nav__link[href^="#"]');
      const entry = this.targets.find((item) => item.link === link);
      if (!entry) return;

      event.preventDefault();
      const offset = this.section.dataset.sticky === 'true' ? this.section.offsetHeight : 0;
      const top = entry.target.getBoundingClientRect().top + window.scrollY - offset;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      history.pushState(null, '', link.hash);
      window.scrollTo({ top: Math.max(0, top), behavior });
      this.setActive(link);
    }

    onScroll() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const threshold = Math.max(0, this.section.getBoundingClientRect().bottom) + 8;
        let active = this.targets[0].link;
        for (const entry of this.targets) {
          if (entry.target.getBoundingClientRect().top <= threshold) active = entry.link;
        }
        this.setActive(active);
      });
    }

    setActive(active) {
      if (this.activeLink === active) return;
      this.activeLink = active;
      for (const link of this.section.querySelectorAll('.e3-ultra-nav__link')) {
        link.classList.remove('e3-ultra-nav__link--active');
      }
      for (const { link } of this.targets) {
        link.classList.toggle('e3-ultra-nav__link--active', link === active);
        if (link === active) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      }
    }

    destroy() {
      if (!this.targets.length) return;
      this.section.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  }

  const e3UltraNavInstances = new WeakMap();

  function initE3UltraNavigation(container = document) {
    for (const section of container.querySelectorAll('.e3-ultra-nav')) {
      if (section.dataset.navigationReady === 'true') continue;
      section.dataset.navigationReady = 'true';
      e3UltraNavInstances.set(section, new E3UltraNavigation(section));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initE3UltraNavigation(), { once: true });
  } else {
    initE3UltraNavigation();
  }
  document.addEventListener('shopify:section:load', (event) => initE3UltraNavigation(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const section of event.target.querySelectorAll('.e3-ultra-nav')) {
      e3UltraNavInstances.get(section)?.destroy();
      e3UltraNavInstances.delete(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-pressure"] && !Shopify.designMode) return;
  try {
    
  const initPressureCarousels = (scope = document) => {
    const sections = scope.matches?.('.e3-ultra-pressure') ? [scope] : scope.querySelectorAll('.e3-ultra-pressure');

    for (const section of sections) {
      const track = section.querySelector('.e3-ultra-pressure__swiper');
      if (!track || track.swiper || track.querySelectorAll('.swiper-slide').length < 2) continue;

      const slides = track.querySelectorAll('.swiper-slide');
      const syncAccessibility = (swiper) => {
        for (const [index, slide] of slides.entries()) {
          slide.setAttribute('aria-hidden', String(index !== swiper.activeIndex));
        }
      };

      new Swiper(track, {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450,
        autoHeight: true,
        rewind: true,
        navigation: {
          prevEl: section.querySelector('.e3-ultra-pressure__arrow--prev'),
          nextEl: section.querySelector('.e3-ultra-pressure__arrow--next'),
        },
        on: {
          init: syncAccessibility,
          slideChange: syncAccessibility,
        },
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => initPressureCarousels(), { once: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-scene"] && !Shopify.designMode) return;
  try {
    
  function initE3UltraScene(root) {
    if (!root || root.dataset.sceneInitialized === 'true') return;
    const tabs = Array.from(root.querySelectorAll('[data-scene-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-scene-panel]'));
    const captions = Array.from(root.querySelectorAll('[data-scene-caption]'));
    if (panels.length === 0 || (tabs.length > 0 && tabs.length !== panels.length)) return;
    root.dataset.sceneInitialized = 'true';
    const section = root.closest('.e3-ultra-scene');
    const autoplay = section.dataset.sceneAutoplay === 'true';
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const videos = Array.from(root.querySelectorAll('video'));
    let inView = false;

    function visibleVideo(panel) {
      if (!panel) return null;
      const variant = mediaQuery.matches ? 'mobile' : 'desktop';
      return panel.querySelector(`.e3-ultra-scene__video--${variant}`);
    }

    function updateControls() {
      for (const panel of panels) {
        const toggle = panel.querySelector('[data-scene-video-toggle]');
        if (!toggle) continue;
        const video = visibleVideo(panel);
        const playing = Boolean(video && !video.paused && !panel.hidden && inView && !document.hidden);
        toggle.dataset.playing = String(playing);
        toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
      }
    }

    function syncVideos() {
      if (!autoplay && (!inView || document.hidden)) {
        for (const panel of panels) delete panel.dataset.scenePaused;
      }
      const activePanel = panels.find((panel) => !panel.hidden);
      const activeVideo = visibleVideo(activePanel);
      const shouldPlay = Boolean(
        inView &&
          !document.hidden &&
          activePanel?.dataset.scenePaused !== 'true' &&
          (autoplay || activePanel?.dataset.scenePaused === 'false')
      );
      for (const video of videos) {
        if (video === activeVideo && shouldPlay) {
          if (video.paused) video.play().catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      }
      updateControls();
    }

    function activate(index, moveFocus) {
      const previous = panels.find((panel) => !panel.hidden);
      if (previous !== panels[index]) {
        for (const video of previous?.querySelectorAll('video') || []) {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (_error) {
            /* Metadata may not be ready. */
          }
        }
      }
      for (let i = 0; i < tabs.length; i += 1) {
        const active = i === index;
        tabs[i].setAttribute('aria-selected', String(active));
        tabs[i].tabIndex = active ? 0 : -1;
        panels[i].hidden = !active;
      }
      for (const caption of captions) {
        caption.hidden = caption.dataset.blockId !== panels[index].dataset.blockId;
      }
      if (previous !== panels[index]) delete panels[index].dataset.scenePaused;
      syncVideos();
      if (moveFocus) tabs[index].focus();
      tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    if (tabs.length > 1) {
      for (let i = 0; i < tabs.length; i += 1) {
        tabs[i].addEventListener('click', () => activate(i, false));
        tabs[i].addEventListener('keydown', (event) => {
          let next = i;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(next, true);
        });
      }
      root.sceneActivateBlock = (blockId) => {
        const index = tabs.findIndex((tab) => tab.dataset.blockId === blockId);
        if (index >= 0) activate(index, false);
      };
    }

    for (const panel of panels) {
      const toggle = panel.querySelector('[data-scene-video-toggle]');
      toggle?.addEventListener('click', () => {
        const video = visibleVideo(panel);
        panel.dataset.scenePaused = video && !video.paused ? 'true' : 'false';
        syncVideos();
      });
    }

    for (const video of videos) {
      video.addEventListener('play', syncVideos);
      video.addEventListener('pause', updateControls);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        inView = entries[0].isIntersecting;
        syncVideos();
      },
      { threshold: 0 }
    );
    observer.observe(section);
    mediaQuery.addEventListener('change', syncVideos);
    document.addEventListener('visibilitychange', syncVideos);
    function onSectionUnload(event) {
      if (!event.target.contains(section)) return;
      observer.disconnect();
      mediaQuery.removeEventListener('change', syncVideos);
      document.removeEventListener('visibilitychange', syncVideos);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
      for (const video of videos) video.pause();
    }
    document.addEventListener('shopify:section:unload', onSectionUnload);
  }

  function initAllE3UltraScenes(scope) {
    for (const root of scope.querySelectorAll('[data-scene-tabs]')) initE3UltraScene(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllE3UltraScenes(document));
  } else {
    initAllE3UltraScenes(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAllE3UltraScenes(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-scene-tabs]');
    root?.sceneActivateBlock(event.detail.blockId);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-subscribe"] && !Shopify.designMode) return;
  try {
    
  const initE3UltraSubscribe = () => {
    if (customElements.get('e3-ultra-subscribe-controller')) return;

    class E3UltraSubscribeController extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.e3-ultra-subscribe');
        if (!this.section) return;
        this.start = this.parseLocalDate(this.section.dataset.startAt);
        this.end = this.parseLocalDate(this.section.dataset.endAt);
        this.minuteGrowth = Math.max(0, Number(this.section.dataset.minuteGrowth) || 0);
        this.form = this.section.querySelector('[data-subscribe-form]');
        this.onSubmit = this.submit.bind(this);
        this.form?.addEventListener('submit', this.onSubmit);
        this.initLearnMoreDialog();
        this.initSubscriptionActivity();
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        window.clearInterval(this.activityTimer);
        this.activityAnimation?.cancel();
        this.activityAnimation = null;
        this.form?.removeEventListener('submit', this.onSubmit);
        this.learnMoreEvents?.abort();
        if (this.learnMoreDialog?.open) this.learnMoreDialog.close();
        this.restoreLearnMoreDialog();
      }

      initLearnMoreDialog() {
        this.learnMoreButton = this.querySelector('[data-learn-more-open]');
        this.learnMoreDialog = this.querySelector('[data-learn-more-dialog]');
        const closeButton = this.querySelector('[data-learn-more-close]');
        if (!this.learnMoreButton || !this.learnMoreDialog || !closeButton) return;
        this.learnMoreEvents = new AbortController();
        const options = { signal: this.learnMoreEvents.signal };
        this.learnMoreButton.addEventListener('click', () => this.openLearnMoreDialog(), options);
        closeButton.addEventListener('click', () => this.learnMoreDialog.close(), options);
        this.learnMoreDialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.learnMoreDialog) this.learnMoreDialog.close();
          },
          options
        );
        this.learnMoreDialog.addEventListener('close', () => this.restoreLearnMoreDialog(), options);
      }

      openLearnMoreDialog() {
        if (this.learnMoreDialog.open) return;
        this.learnMoreDialog.showModal();
        this.learnMoreDialog.scrollTop = 0;
        this.learnMoreOverflow = [document.documentElement, document.body].map((element) => ({
          element,
          value: element.style.getPropertyValue('overflow'),
          priority: element.style.getPropertyPriority('overflow'),
        }));
        for (const { element } of this.learnMoreOverflow) element.style.setProperty('overflow', 'hidden', 'important');
      }

      restoreLearnMoreDialog() {
        if (!this.learnMoreOverflow) return;
        for (const { element, value, priority } of this.learnMoreOverflow) {
          if (value) element.style.setProperty('overflow', value, priority);
          else element.style.removeProperty('overflow');
        }
        this.learnMoreOverflow = null;
        if (this.isConnected) this.learnMoreButton?.focus({ preventScroll: true });
      }

      initSubscriptionActivity() {
        this.activity = this.section.querySelector('[data-subscription-activity]');
        this.activityTrack = this.activity?.querySelector('[data-activity-track]');
        if (!this.activityTrack) return;
        this.activityTrack.replaceChildren(this.createActivityItem(), this.createActivityItem());
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.activityTimer = window.setInterval(() => {
          if (document.hidden || this.activityAnimation) return;
          this.activityAnimation = this.activityTrack.animate(
            [{ transform: 'translateY(0)' }, { transform: 'translateY(-50%)' }],
            { duration: 600, easing: 'ease-in-out', fill: 'forwards' }
          );
          this.activityAnimation.onfinish = () => {
            this.activityTrack.firstElementChild.remove();
            this.activityTrack.append(this.createActivityItem());
            this.activityAnimation.cancel();
            this.activityAnimation = null;
          };
        }, 3500);
      }

      /** @returns {HTMLSpanElement} A simulated subscription with a masked email. */
      createActivityItem() {
        // Two random letters, six masking characters, and two digits; no customer data is used.
        const prefix = String.fromCharCode(65 + Math.floor(Math.random() * 26), 97 + Math.floor(Math.random() * 26));
        const suffix = String(Math.floor(Math.random() * 100)).padStart(2, '0');
        const domains = [
          'gmail.com',
          'outlook.com',
          'hotmail.com',
          'yahoo.com',
          'icloud.com',
          'aol.com',
          'live.com',
          'proton.me',
        ];
        const domain = domains[Math.floor(Math.random() * domains.length)];
        const email = `${prefix}******${suffix}@${domain}`;
        const item = document.createElement('span');
        item.className = 'e3-ultra-subscribe__notice-item';
        item.textContent = this.activity.dataset.messageTemplate.replaceAll('[email]', email);
        return item;
      }

      parseLocalDate(value) {
        const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value || '');
        if (!match) return NaN;
        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);
        const hour = Number(match[4]);
        const minute = Number(match[5]);
        const second = Number(match[6] || 0);
        const date = new Date(year, month - 1, day, hour, minute, second);
        if (
          date.getFullYear() !== year ||
          date.getMonth() !== month - 1 ||
          date.getDate() !== day ||
          date.getHours() !== hour ||
          date.getMinutes() !== minute
        )
          return NaN;
        return date.getTime();
      }

      tick() {
        const now = Date.now();
        const hasStart = Number.isFinite(this.start);
        const hasEnd = Number.isFinite(this.end);
        const ended = hasEnd && now >= this.end;
        const before = hasStart && now < this.start;
        const target = before ? this.start : this.end;
        const remaining = Number.isFinite(target) ? Math.max(0, Math.ceil((target - now) / 1000)) : 0;
        const parts = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor(remaining / 3600) % 24,
          minutes: Math.floor(remaining / 60) % 60,
          seconds: remaining % 60,
        };
        for (const [unit, value] of Object.entries(parts)) {
          const node = this.section.querySelector(`[data-countdown-unit="${unit}"]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        }
        const heading = this.section.querySelector('[data-countdown-heading]');
        if (heading)
          heading.textContent = ended
            ? heading.dataset.after
            : before
            ? heading.dataset.before
            : heading.dataset.during;

        // The count starts at zero and increases smoothly at the configured per-minute rate.
        const elapsed = hasStart ? Math.max(0, Math.min(now, hasEnd ? this.end : now) - this.start) : 0;
        const count = Math.floor((elapsed / 60000) * this.minuteGrowth);
        const progress = this.section.querySelector('[data-progress]');
        const thresholds = [...this.section.querySelectorAll('[data-threshold]')].map((node) => {
          const threshold = Math.max(0, Number(node.dataset.threshold) || 0);
          node.dataset.unlocked = String(count >= threshold);
          const label = node.querySelector('.e3-ultra-subscribe__reward-threshold');
          if (label) label.textContent = threshold.toLocaleString();
          return threshold;
        });
        const goals = [...new Set(thresholds.filter((value) => value > 0))].sort((a, b) => a - b);
        const max = goals[goals.length - 1] || 0;
        if (progress) {
          progress.setAttribute('aria-valuenow', String(Math.min(count, max)));
          progress.setAttribute('aria-valuemax', String(max));
          progress.setAttribute(
            'aria-valuetext',
            `${count.toLocaleString()} ${progress.dataset.subscriberLabel || ''}`.trim()
          );
          const fill = progress.querySelector('[data-progress-fill]');
          if (fill) {
            // Reward locks are evenly spaced, while their subscriber goals are not.
            // Interpolate between lock positions so 600 falls between 200 and 1,000.
            let percent = 0;
            let previousGoal = 0;
            let previousPercent = 0;
            for (const [index, goal] of goals.entries()) {
              const goalPercent = index === goals.length - 1 ? 100 : ((index + 0.5) / goals.length) * 100;
              if (count <= goal) {
                percent =
                  previousPercent + ((count - previousGoal) / (goal - previousGoal)) * (goalPercent - previousPercent);
                break;
              }
              previousGoal = goal;
              previousPercent = goalPercent;
              percent = 100;
            }
            percent = Math.max(0, Math.min(100, percent));
            fill.style.setProperty('--e3-progress-percent', `${percent}%`);
          }
        }
        const button = this.section.querySelector('[data-submit]');
        if (button && !button.dataset.loading) button.disabled = ended;
        if (ended && !this.endedShown) {
          this.endedShown = true;
          const message = this.section.querySelector('[data-form-message]');
          const subscribe = this.section.querySelector('[data-subscribe]');
          if (message && subscribe?.dataset.endedMessage) {
            message.textContent = subscribe.dataset.endedMessage;
            message.hidden = false;
          }
        }
      }

      async submit(event) {
        event.preventDefault();
        const subscribe = this.section.querySelector('[data-subscribe]');
        const button = this.section.querySelector('[data-submit]');
        const message = this.section.querySelector('[data-form-message]');
        const email = this.form?.querySelector('[name="email"]');
        const agreement = this.section.querySelector('[data-agreement]');
        if (!subscribe || !button || !email || !message || !this.form.reportValidity()) return;
        if (agreement && !agreement.checked) {
          agreement.focus();
          return;
        }
        if (Number.isFinite(this.end) && Date.now() >= this.end) return;
        button.disabled = true;
        button.dataset.loading = 'true';
        message.hidden = true;
        try {
          if (!subscribe.dataset.companyId || !subscribe.dataset.listId)
            throw new Error('Missing Klaviyo configuration');
          const url = new URL('https://a.klaviyo.com/client/subscriptions');
          url.searchParams.set('company_id', subscribe.dataset.companyId);
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              revision: '2024-10-15',
              accept: 'application/vnd.api+json',
              'content-type': 'application/vnd.api+json',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: subscribe.dataset.source,
                  profile: { data: { type: 'profile', attributes: { email: email.value.trim() } } },
                },
                relationships: { list: { data: { type: 'list', id: subscribe.dataset.listId } } },
              },
            }),
          });
          if (!response.ok) throw new Error(`Klaviyo HTTP ${response.status}`);
          message.textContent = subscribe.dataset.successMessage;
          message.hidden = false;
          this.form.reset();
          if (
            window.location.hostname === 'de.hbada.com' &&
            window.location.pathname.replace(/\/$/, '') === '/pages/hbada-e3-ultra' &&
            window.Shopify?.analytics?.publish
          ) {
            window.Shopify.analytics.publish('hbada:subscribe_success', {
              country: 'DE',
              product: 'E3 Ultra',
              page_location: window.location.href,
            });
          }
        } catch (error) {
          console.error(error);
          message.textContent = subscribe.dataset.errorMessage;
          message.hidden = false;
        } finally {
          delete button.dataset.loading;
          button.disabled = Number.isFinite(this.end) && Date.now() >= this.end;
        }
      }
    }

    customElements.define('e3-ultra-subscribe-controller', E3UltraSubscribeController);
  };

  document.addEventListener('DOMContentLoaded', initE3UltraSubscribe, { once: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-upgrade"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const sections = root.matches?.('[data-e3-upgrade]')
        ? [root]
        : root.querySelectorAll('[data-e3-upgrade]');

      for (const section of sections) {
        if (section.dataset.e3UpgradeInitialized === 'true') continue;
        section.dataset.e3UpgradeInitialized = 'true';

      const dropdown = section.querySelector('[data-dropdown]');
      const trigger = section.querySelector('[data-dropdown-trigger]');
      const options = [...section.querySelectorAll('[data-option-index]')];
      const panels = [...section.querySelectorAll('[data-panel]')];

      if (!dropdown || !trigger || options.length === 0 || panels.length === 0) continue;

      const closeDropdown = () => {
        dropdown.open = false;
        trigger.setAttribute('aria-expanded', 'false');
      };

      const selectOption = (index, returnFocus = true) => {
        const selectedOption = options[index];

        if (!selectedOption) return;

        for (const option of options) {
          option.setAttribute('aria-selected', option === selectedOption ? 'true' : 'false');
        }

        for (const panel of panels) {
          const isSelected = panel.dataset.panelIndex === String(index);
          panel.hidden = !isSelected;
          panel.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
        }

        const value = trigger.querySelector('[data-dropdown-value]');
        if (value) value.textContent = selectedOption.textContent.trim();

        closeDropdown();
        if (returnFocus) trigger.focus();
      };

      dropdown.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', dropdown.open ? 'true' : 'false');
      });

      for (const option of options) {
        option.addEventListener('click', (event) => {
          event.preventDefault();
          selectOption(Number(option.dataset.optionIndex));
        });
      }

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          dropdown.open = true;
          trigger.setAttribute('aria-expanded', 'true');
          options[event.key === 'ArrowDown' ? 0 : options.length - 1].focus();
        }
      });

      for (const option of options) {
        option.addEventListener('keydown', (event) => {
          const currentIndex = Number(option.dataset.optionIndex);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowDown') nextIndex = Math.min(currentIndex + 1, options.length - 1);
          if (event.key === 'ArrowUp') nextIndex = Math.max(currentIndex - 1, 0);
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = options.length - 1;

          if (nextIndex !== currentIndex) {
            event.preventDefault();
            options[nextIndex].focus();
          }

          if (event.key === 'Escape') {
            event.preventDefault();
            closeDropdown();
            trigger.focus();
          }
        });
      }

      document.addEventListener('click', (event) => {
        if (!dropdown.contains(event.target)) closeDropdown();
      });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e3-ultra-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initVideoCarousels = () => {
      const carousels = document.querySelectorAll('[data-video-carousel]');

      for (const carousel of carousels) {
        if (carousel.dataset.videoCarouselInitialized === 'true') continue;
        carousel.dataset.videoCarouselInitialized = 'true';

        const slides = [...carousel.querySelectorAll('[data-slide-index]')];
        const slidesContainer = carousel.querySelector('.e3-ultra-video__slides');
        const videos = slides.map((slide) => slide.querySelector('video'));
        const previousButton = carousel.querySelector('[data-video-previous]');
        const nextButton = carousel.querySelector('[data-video-next]');
        const soundButton = carousel.querySelector('[data-video-sound]');
        const controller = new AbortController();
        const listenerOptions = { signal: controller.signal };
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
        let isMuted = true;
        let isEditorSelected = false;
        let isFullyVisible = false;
        let shouldPlayActiveVideo = carousel.dataset.autoplay === 'true' && !reducedMotion;

        if (!slides.length || !slidesContainer) continue;

        const updateSoundButton = () => {
          soundButton?.setAttribute('aria-pressed', String(!isMuted));
          soundButton?.setAttribute('aria-label', isMuted ? carousel.dataset.mutedLabel : carousel.dataset.unmutedLabel);
          soundButton?.setAttribute('data-muted', String(isMuted));
          if (soundButton) soundButton.disabled = !videos[activeIndex];
        };

        const updateArrowButtons = () => {
          if (previousButton) {
            previousButton.disabled = activeIndex <= 0;
            previousButton.setAttribute('aria-disabled', String(previousButton.disabled));
          }
          if (nextButton) {
            nextButton.disabled = activeIndex >= slides.length - 1;
            nextButton.setAttribute('aria-disabled', String(nextButton.disabled));
          }
        };

        const playActiveVideo = () => {
          const activeVideo = videos[activeIndex];
          if (!activeVideo || !isFullyVisible) return;
          const bounds = slidesContainer.getBoundingClientRect();
          if (
            bounds.width <= 0 || bounds.height <= 0 ||
            bounds.top < 0 || bounds.left < 0 ||
            bounds.bottom > document.documentElement.clientHeight ||
            bounds.right > document.documentElement.clientWidth
          ) return;
          activeVideo.muted = isMuted;
          const playPromise = activeVideo.play();
          playPromise?.catch(() => {});
        };

        const showSlide = (nextIndex, shouldPlay = true) => {
          shouldPlayActiveVideo = shouldPlay;
          activeIndex = Math.min(Math.max(nextIndex, 0), slides.length - 1);

          for (let index = 0; index < slides.length; index += 1) {
            const isActive = index === activeIndex;
            const slide = slides[index];
            const video = videos[index];
            slide.classList.toggle('is-active', isActive);
            slide.hidden = !isActive;
            slide.setAttribute('aria-hidden', String(!isActive));

            if (video) {
              video.pause();
              video.currentTime = 0;
              video.muted = isMuted;
            }
          }

          updateSoundButton();
          updateArrowButtons();
          if (shouldPlay) playActiveVideo();
        };

        const visibilityObserver = new IntersectionObserver(([entry]) => {
          isFullyVisible = entry.isIntersecting && entry.intersectionRatio === 1;
          const activeVideo = videos[activeIndex];
          if (!isFullyVisible) {
            activeVideo?.pause();
            return;
          }
          if (!shouldPlayActiveVideo || !activeVideo) return;
          if (activeVideo.ended) activeVideo.currentTime = 0;
          playActiveVideo();
        }, { threshold: 1 });

        previousButton?.addEventListener('click', () => showSlide(activeIndex - 1), listenerOptions);
        nextButton?.addEventListener('click', () => showSlide(activeIndex + 1), listenerOptions);
        soundButton?.addEventListener('click', () => {
          isMuted = !isMuted;
          for (const video of videos) {
            if (video) video.muted = isMuted;
          }
          updateSoundButton();
        }, listenerOptions);

        for (const [index, video] of videos.entries()) {
          if (!video) continue;
          video.addEventListener('ended', () => {
            if (index === activeIndex && !isEditorSelected && index < slides.length - 1) showSlide(activeIndex + 1);
          }, listenerOptions);
        }

        carousel.addEventListener('shopify:block:select', (event) => {
          const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          isEditorSelected = true;
          showSlide(index);
        }, listenerOptions);
        carousel.addEventListener('shopify:block:deselect', () => {
          isEditorSelected = false;
        }, listenerOptions);
        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(carousel)) return;
          visibilityObserver.disconnect();
          controller.abort();
          for (const video of videos) video?.pause();
          delete carousel.dataset.videoCarouselInitialized;
        }, listenerOptions);

        showSlide(activeIndex, shouldPlayActiveVideo);
        visibilityObserver.observe(slidesContainer);
      }
    };

    document.addEventListener('DOMContentLoaded', initVideoCarousels);
    document.addEventListener('shopify:section:load', initVideoCarousels);
    initVideoCarousels();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq-detail').forEach((sectionEl) => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      sectionEl.querySelectorAll('.faq-detail__item').forEach((itemEl) => {
        const summaryEl = itemEl.querySelector('.faq-detail__summary');
        const panelEl = itemEl.querySelector('[data-faq-detail-panel]');

        if (!summaryEl || !panelEl) {
          return;
        }

        const measurePanel = () => {
          const wasOpen = itemEl.open;
          const inlineMaxHeight = panelEl.style.maxHeight;

          if (!wasOpen) {
            itemEl.open = true;
          }

          panelEl.style.maxHeight = 'none';
          panelEl.style.setProperty('--faq-detail-answer-height', `${panelEl.scrollHeight}px`);
          panelEl.style.maxHeight = inlineMaxHeight;

          if (!wasOpen) {
            itemEl.open = false;
          }
        };

        const getMeasuredHeight = () =>
          window.getComputedStyle(panelEl).getPropertyValue('--faq-detail-answer-height').trim() || '0px';

        const finishOpen = () => {
          itemEl.classList.remove('is-opening');
          panelEl.style.maxHeight = '';
        };

        const finishClose = () => {
          itemEl.classList.remove('is-closing');
          itemEl.open = false;
          panelEl.style.maxHeight = '';
        };

        const onOpenTransitionEnd = (transitionEvent) => {
          if (transitionEvent.propertyName !== 'max-height') {
            return;
          }

          panelEl.removeEventListener('transitionend', onOpenTransitionEnd);
          finishOpen();
        };

        const onCloseTransitionEnd = (transitionEvent) => {
          if (transitionEvent.propertyName !== 'max-height') {
            return;
          }

          panelEl.removeEventListener('transitionend', onCloseTransitionEnd);
          finishClose();
        };

        summaryEl.addEventListener('click', (event) => {
          if (reduceMotion.matches) {
            return;
          }

          event.preventDefault();

          if (itemEl.classList.contains('is-opening') || itemEl.classList.contains('is-closing')) {
            return;
          }

          if (itemEl.open) {
            const measuredHeight = getMeasuredHeight();

            itemEl.classList.add('is-closing');
            panelEl.style.maxHeight = measuredHeight;

            requestAnimationFrame(() => {
              panelEl.style.maxHeight = '0px';
            });

            if (parseFloat(measuredHeight) <= 0) {
              finishClose();
              return;
            }

            panelEl.addEventListener('transitionend', onCloseTransitionEnd);
            return;
          }

          const measuredHeight = getMeasuredHeight();

          itemEl.open = true;
          itemEl.classList.add('is-opening');
          panelEl.style.maxHeight = '0px';

          requestAnimationFrame(() => {
            panelEl.style.maxHeight = measuredHeight;
          });

          if (parseFloat(measuredHeight) <= 0) {
            finishOpen();
            return;
          }

          panelEl.addEventListener('transitionend', onOpenTransitionEnd);
        });

        measurePanel();
        window.addEventListener('load', measurePanel);
        window.addEventListener('resize', measurePanel);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-help"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-faq-help]').forEach((sectionEl) => {
      const onlineButton = sectionEl.querySelector('[data-faq-help-online]');

      if (!onlineButton) {
        return;
      }

      onlineButton.addEventListener('click', () => {
        window?.vanchat_widget?.open();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-faq-nav]').forEach((sectionEl) => {
      const sliderEl = sectionEl.querySelector('[data-faq-nav-slider]');
      const prevEl = sectionEl.querySelector('[data-faq-nav-prev]');
      const nextEl = sectionEl.querySelector('[data-faq-nav-next]');

      if (!sliderEl || !prevEl || !nextEl) {
        return;
      }

      const scrollByPage = (direction) => {
        const pageEl = sliderEl.querySelector('.faq-nav__page');

        if (!pageEl) {
          return;
        }

        const gap = parseFloat(window.getComputedStyle(sliderEl).columnGap || '0');
        sliderEl.scrollBy({
          left: direction * (pageEl.getBoundingClientRect().width + gap),
          behavior: 'smooth',
        });
      };

      prevEl.addEventListener('click', () => scrollByPage(-1));
      nextEl.addEventListener('click', () => scrollByPage(1));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hbada-blog-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-hbada-blog-article]').forEach((section) => {
      const dock = section.querySelector('[data-hbada-article-share-dock]');
      const newsletterForms = section.querySelectorAll('[data-hbada-newsletter-form]');
      let hideTimer = null;

      const updateDock = () => {
        if (!dock) {
          return;
        }

        const shouldShow = window.scrollY > window.innerHeight;

        if (shouldShow) {
          window.clearTimeout(hideTimer);
          dock.classList.remove('is-hiding');
          dock.classList.add('is-visible');
          dock.setAttribute('aria-hidden', 'false');
          return;
        }

        if (dock.classList.contains('is-visible')) {
          dock.classList.remove('is-visible');
          dock.classList.add('is-hiding');
          dock.setAttribute('aria-hidden', 'true');

          window.clearTimeout(hideTimer);
          hideTimer = window.setTimeout(() => {
            dock.classList.remove('is-hiding');
          }, 660);
          return;
        }

        dock.setAttribute('aria-hidden', 'true');
      };

      newsletterForms.forEach((form) => {
        form.addEventListener('submit', () => {
          const submitButton = form.querySelector('[data-hbada-newsletter-submit]');

          form.classList.add('is-loading');
          form.setAttribute('aria-busy', 'true');

          if (submitButton) {
            submitButton.disabled = true;
            submitButton.setAttribute('aria-busy', 'true');
          }
        });
      });

      updateDock();
      window.addEventListener('scroll', updateDock, { passive: true });
      window.addEventListener('resize', updateDock);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
